import { render } from "./PlayoutAddSourceModal.vue?vue&type=template&id=a6a16ca0"
import script from "./PlayoutAddSourceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutAddSourceModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutAddSourceModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6a16ca0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6a16ca0', __exports__)) {
    api.reload('a6a16ca0', __exports__)
  }
  
  module.hot.accept("./PlayoutAddSourceModal.vue?vue&type=template&id=a6a16ca0", () => {
    api.rerender('a6a16ca0', render)
  })

}


export default __exports__